// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"4b53f739","240":"313f5b7e","241":"86dbadfb","300":"9e9e0b4f","505":"1a2e1093","696":"873dfdf7","805":"c3ebc243","885":"7fd11296","996":"e3e423ff"}[chunkId] + ".chunk.js";
};